import { Link, createFileRoute } from '@tanstack/react-router';
import { ArrowLeft, HandCoins } from 'lucide-react';
import { useAtLeast } from '@/lib/auth';
import { Button } from '@/ui/Button';
import { GiftCardDetail } from '@/ui/GiftCardDetail';
import { Page, PageBody, PageHeader } from '@/ui/Panel';

export const Route = createFileRoute('/_app/gift-cards_/$id')({
  staticData: { crumb: 'Card' },
  component: GiftCardScreen,
});

function GiftCardScreen() {
  const { id } = Route.useParams();
  const isManager = useAtLeast('manager');

  return (
    <Page>
      <PageHeader
        eyebrow="Gift cards"
        title={`Card #${id}`}
        subtitle="Balance, recipient and full movement history"
        actions={
          <>
            <Button
              asChild
              variant="ghost"
              size="sm"
              icon={<ArrowLeft className="size-3.5" />}
            >
              <Link
                to="/gift-cards"
                search={{ q: '', status: 'all', sort: 'created', order: 'desc', page: 1 }}
              >
                All cards
              </Link>
            </Button>
            {isManager ? (
              <Button asChild size="sm" icon={<HandCoins className="size-3.5" />}>
                <Link to="/account-credits" search={{ cardId: id }}>
                  Apply unused value
                </Link>
              </Button>
            ) : null}
          </>
        }
      />
      <PageBody>
        <div className="mx-auto max-w-3xl">
          <GiftCardDetail id={Number(id)} />
        </div>
      </PageBody>
    </Page>
  );
}
